import { createTheme } from '@mui/material/styles';

const defaultTheme = createTheme();

/**
 * Sequire theme primitives:
 */
export const colorSchemes = {
    light: {
        palette: {
            primary: {
                main: '#008580',
                mainLight: '#E3F2F1',
                light: '#76B1AC',
                dark: '#145F5C',
            },
            secondary: {
                main: '#284C4C',
                light: '#3d6b6b',
                dark: '#145F5C',
            },
            background: {
                default: '#F4F4F4',
                paper: '#FFFFFF',
            },
            text: {
                primary: '#000000',
                secondary: '#44444',
                contrastText: '#FFFFFF',
            },
            divider: '#E0E0E0',
            success: {
                main: '#4B9B96',
                light: '#B1D2CF',
                dark: '#31908B',
            },
            info: {
                main: '#008580',
                light: '#76B1AC',
                dark: '#145F5C',
            },
            error: {
                main: '#D32F2F',
                light: '#FFCDD2',
                dark: '#B71C1C',
            },
        },
    },
    dark: {
        palette: {
            background: {
                default: defaultTheme.palette.grey[900],
                paper: defaultTheme.palette.grey[800],
            },
        },
    },
};

export const typography = {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: { fontWeight: 700 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 600 },
    h4: { fontWeight: 600 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    body1: { color: '#444444' },
    body2: { color: '#757575' },
    body3: { color: '#3a3a3a' },
};

export const shape = {
    borderRadius: 8,
};

export const shadows = [
    'none',
    '0px 2px 4px rgba(0,0,0,0.06)',
    '0px 4px 8px rgba(0,0,0,0.08)',
    '0px 6px 12px rgba(0,0,0,0.08)',
    ...Array(21).fill('0px 8px 16px rgba(0,0,0,0.08)'),
];
